import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  class: "am2-provider-icon-wrapper__icon",
  style: {"width":"18px","height":"18px"},
  viewBox: "0 0 600 600"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("circle", {
      cx: "300",
      cy: "300",
      r: "300",
      fill: "currentColor"
    }, null, -1),
    _createElementVNode("path", {
      fill: "#fff",
      d: "M455.31 140.43c-.52.09-111.76 14.8-111.76 14.8S301.14 52.87 296.91 48.64s-6.66.74-6.66.74l-34.79 105.11s-121.46 6.63-128.79 6.66-4.35 5-3 6.66c.86.68 76.73 90.65 80.68 93.27 3.14 2.65 3 5.18 3 5.18s14.46 249.32 14.8 262c1 16 10.37 2.22 10.37 2.22L299 437s16.93-24.65 17.12-24.89c1.48-2.22 3-2.22 3-2.22l124.35 13.32s7.65 1.7 4.44-5.18c-18.32-40-68.1-149.52-68.1-149.52L459 148.57c5.81-9.32 3.5-9.07-3.69-8.14m-98.44 93.88h-34.61v137.8h-41.08v-137.8h-34.6v-37.63h110.29Z"
    }, null, -1)
  ])))
}
export default { render: render }